export default "__VITE_ASSET__DkKJDid5__"